<template>
  <!-- 面包屑 -->
  <div class="row crumbs-view none-select">
    <div class="row crumbs-main main-w">
      <div class="row crumbs-item link" @click="toHome">首页</div>
      <el-icon
        class="row crumbs-item el-icon-arrow-right"
        style="color: #017575; font-weight: 700"
      ></el-icon>
      <div class="row crumbs-item link"><slot name="current"></slot></div>
    </div>
    <div class="right">
      <slot name="date"> </slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    toHome() {
      this.$router.push({path: '/'});
      this.$emit('toIndex', true)
    }
  }
};
</script>

<style scoped lang="less">
// 面包屑导航
.crumbs-view {
  font-size: 18px;
  width: 100%;
  margin-top: 40px;
  margin-bottom: 40px;
  align-items: center;
  .crumbs-main {
    margin: 40px 0;
    font-weight: 500;
    color: #017575;
    .crumbs-item {
      margin-right: 6px;
      align-items: center;
    }
  }
  .right {
    flex-shrink: 0;
    display: flex;
    font-size: 18px;
    font-weight: 500;
    width: 280px;

    .date {
      color: #666;
      margin-right: 30px;
    }
    .number {
      color: #333;
    }
  }
}
</style>
